module.exports = __webpack_public_path__ + "static/media/login.811cc9ee.811cc9ee.png";